export const formatPrice = (price) => {
  if (!price) return "0.00";
  let num = typeof price === "string" ? parseFloat(price) : price;
  let money = num;
  if (Math.abs(num) >= 1000000) {
    money = (Math.abs(num) / 1000000).toFixed(1) + "m";
  } else if (Math.abs(num) >= 1000) {
    money = (Math.abs(num) / 1000).toFixed(1) + "k";
  } else {
    money = Math.sign(num) * Math.abs(num);
  }
  return `₦${money}`;
};
